var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from "axios";
import { sampleFilePathMapping } from "../constants_map";
export var getSampleFilePath = function (mappingId, folderName) {
    var fileName = sampleFilePathMapping[mappingId];
    console.log("getratesheet", mappingId, fileName, folderName);
    if (!fileName)
        return "/samplefiles/".concat(mappingId);
    if (!folderName)
        return "/samplefiles/".concat(fileName);
    return "/samplefiles/".concat(folderName, "/").concat(fileName);
};
export var formatBytes = function (bytes, decimals) {
    if (decimals === void 0) { decimals = 2; }
    if (bytes === 0)
        return "0 Bytes";
    var k = 1024; // 1 KB = 1024 Bytes
    var sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB"];
    var i = Math.floor(Math.log(bytes) / Math.log(k));
    return "".concat(parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)), " ").concat(sizes[i]);
};
export var imageUrlToBase64 = function (url, token) { return __awaiter(void 0, void 0, void 0, function () {
    var response, blob_1, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, axios.get(url, {
                        responseType: "blob",
                        headers: {
                            Authorization: "Bearer ".concat(token),
                        },
                    })];
            case 1:
                response = _a.sent();
                blob_1 = response.data;
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        try {
                            var reader_1 = new FileReader();
                            reader_1.readAsDataURL(blob_1);
                            reader_1.onloadend = function () {
                                resolve(reader_1.result);
                            };
                        }
                        catch (e) {
                            reject(e);
                        }
                    })];
            case 2:
                error_1 = _a.sent();
                console.error("There was an error fetching the image:", error_1);
                throw error_1;
            case 3: return [2 /*return*/];
        }
    });
}); };
export function addNumberToFileName(fileName, number) {
    if (number === void 0) { number = Math.floor(Math.random() * 10000); }
    // Split filename into name and extension
    var dotIndex = fileName.lastIndexOf(".");
    if (dotIndex === -1) {
        // No extension — just append the number
        fileName = "".concat(fileName, "_").concat(number);
    }
    var name = fileName.slice(0, dotIndex);
    var extension = fileName.slice(dotIndex); // includes the dot, e.g. ".jpg"
    fileName = "".concat(name, "_").concat(number).concat(extension);
    return fileName;
}
